import * as React from 'react';
import { createContext, useContext } from 'react';
import { usePlanSelection, PlanSelectionHook } from './use-plan-selection';
import { CheckoutModal } from './checkout-modal';
import { ConflictModal } from './conflict-modal';

// ─── Context ──────────────────────────────────────────────────────────────────

const PlanSelectionContext = createContext<PlanSelectionHook | null>(null);

// ─── Provider ─────────────────────────────────────────────────────────────────

export const PlanSelectionProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const selection = usePlanSelection();

  return (
    <PlanSelectionContext.Provider value={selection}>
      {children}

      {/* Checkout modal (2-step) */}
      <CheckoutModal
        open={selection.checkoutOpen}
        cart={selection.cart}
        step={selection.checkoutStep}
        onClose={selection.closeCheckout}
        onNextStep={() => selection.setCheckoutStep(2)}
        onRemovePlan={selection.removePlanFromCart}
      />

      {/* Conflict confirmation dialog */}
      <ConflictModal
        open={!!selection.conflictInfo}
        message={selection.conflictInfo?.message ?? ''}
        onConfirm={selection.confirmConflict}
        onCancel={selection.cancelConflict}
      />
    </PlanSelectionContext.Provider>
  );
};

// ─── Hook ─────────────────────────────────────────────────────────────────────

export const usePlanSelectionCtx = (): PlanSelectionHook => {
  const ctx = useContext(PlanSelectionContext);
  if (!ctx) throw new Error('usePlanSelectionCtx must be used within <PlanSelectionProvider>');
  return ctx;
};
